import { Injectable } from '@angular/core';

import { allCountries } from '../../shared/countries';

declare var moment: any;

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor() { }

  // stringy said object - and returns it
  public stringifyObject(object): string {
    return JSON.stringify(object);
  }

  // uppercase first letter of string
  public uppercaseFirstLetter(word) {
    const theWord = String(word);
    let upperFLW = '';

    for (let w = 0; w < theWord.length; w++) {
      if (w === 0) {
        upperFLW = theWord[0].toUpperCase();
      } else if (theWord[w - 1] === ' ') {
        upperFLW += theWord[w].toUpperCase();
      } else {
        upperFLW += theWord[w];
      }
    }
    return upperFLW;
  }

  // return country name
  public getCountryName(countryCode) {
    const countries = allCountries;
    let countryName = '';

    for (let c = 0; c < countries.length; c++) {
      if (countryCode === countries[c].type) {
        countryName = countries[c].name + ` (${countries[c].type})`;
        break;
      }
    }

    return countryName;
  }

  // check if claimed or not
  public voucherIsClaimed(voucher) {
    if (voucher === 0) {
      return '0';
    } else {
      return voucher;
    }
  }

  // return subscription type
  public getSubscription(user) {
    const userObj = user;
    let subscriptionType;

    if (!(userObj.subscription !== null) || userObj.subscription !== '') {
      subscriptionType = this.uppercaseFirstLetter(JSON.parse(userObj.subscription).account.package);
    } else {
      subscriptionType = 'null';
    }

    return subscriptionType;
  }

  // returns a date
  public returnDate(date, template) {
    switch (template) {
      case 'moment':
        return moment(new Date(date).toISOString());

      case 'simple':
        return moment(date).format('MMMM D YYYY');

      default:
        return moment(date).format('MMMM D YYYY h:mm:ss A');
    }
  }

  // sort data by date
  public sortArrayByDate(dataArray) {
    dataArray.sort(function (a, b) {
      return new Date(b.date).getTime() - new Date(a.date).getTime();
    });
   return dataArray;
  }

  // return item
  public returnItem(transactionObj, type) {
    let item = '';

    switch (type) {
      case 'all':

        if (transactionObj.hasOwnProperty('account')) {
          item = transactionObj.account.package;

          if (item.includes('beginner')) {
            item = 'Beginner Account';
          }
          if (item.includes('developer')){
            item = "Developer Account"
          }
    

        } else if (transactionObj.hasOwnProperty('sms')) {
          item = transactionObj.sms.package;
          if (item.includes('sms_p1') || item.includes('sms_p2')) {
            item = item.toUpperCase().replace('_', ' ');
          }
        }
        break;

      case 'subs':
        if (transactionObj.hasOwnProperty('account')) {
          item = transactionObj.account.package;

          if (item.includes('beginner')) {
            item = 'Beginner Plan';
          }
        }

        break;
      case 'exp':
        if (transactionObj.hasOwnProperty('account')) {
          item = this.returnDate(transactionObj.account.expired_date, 'simple');
        }
        break;
      case 'code':
        if (transactionObj.hasOwnProperty('account')) {
          item = transactionObj.account.voucher_code;
        }
        break;

      case 'sms':
        if (transactionObj.hasOwnProperty('sms')) {
          item = transactionObj.sms.package;
          if (item.includes('sms_p1') || item.includes('sms_p2')) {
            item = item.toUpperCase().replace('_', ' ');
          }
        }
        break;
    }

    return item;
  }

  // return what voucher it is for
  public returnVoucherUseFor(voucherWhat) {
    if (voucherWhat === 'iot' || voucherWhat === 'iot-platform') {
      return 'IOT Platform';
    }
  }
}
